module.exports = __webpack_public_path__ + "img/competitive-promo-materials.3c88e4d0.png";